module.exports = __webpack_public_path__ + "22_ickg.jpg?abe499172f6f3def0911b2c02ee7ee82";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_ickg.jpg
// module id = 183
// module chunks = 0